import { gql } from '@apollo/client';

export default gql`
  mutation confirmUser(
    $email: String!
    $token: String!
  ) {
    confirmUser(
      input: { email: $email, token: $token }
    ) {
      user {
        id
        email
      }
      expiresIn
    }
  }
`;
